var map = {
	"./alarmstatistics/router.js": "kAG+",
	"./chatbot/router.js": "2Rkr",
	"./dataQuery/router.js": "Q03O",
	"./diagnose/router.js": "8acz",
	"./dmp/router.js": "Glk5",
	"./knowledge/router.js": "BYZu",
	"./knowledgeGraph/router.js": "gYlv",
	"./malf/router.js": "NTnL",
	"./mycare/router.js": "qG2c",
	"./queryTools/router.js": "Hs/N",
	"./rootCause/router.js": "4mUj"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8n87";


//////////////////
// WEBPACK FOOTER
// ./src/views ^\.\/.*\/router\.js$
// module id = 8n87
// module chunks = 37